import { ComposedElement } from "../ComposedElement.mjs";
export var CalloutNode;

(function (CalloutNode) {
  CalloutNode.TYPE = 'callout';

  function isCalloutNode(value) {
    return ComposedElement.isComposedElement(value, CalloutNode.TYPE);
  }

  CalloutNode.isCalloutNode = isCalloutNode;

  function validateCalloutNode(value, validateInlineNode) {
    var isValid = ComposedElement.validateComposedElement(value, CalloutNode.TYPE, validateInlineNode) && (typeof value.icon === 'string' || typeof value.icon === 'undefined') && (typeof value.align === 'string' || typeof value.align === 'undefined');
    return isValid ? value : null;
  }

  CalloutNode.validateCalloutNode = validateCalloutNode;
})(CalloutNode || (CalloutNode = {}));